module.exports = __webpack_public_path__ + "static/media/screen_main_plus_12.ec9a2c69.svg";